export default {
  // Page Title
  pageTitle: "AI Model",

  // Buttons
  addModel: "Add Model",
  reset: "Reset",
  query: "Query",
  download: "Download",

  // Search Area
  selectCaseName: "Please select case name",
  inputAddress: "Please enter address",

  // Statistics
  totalCount: "Total",
  totalData: "data records",
  selected: "Selected",
  items: "items",

  // Loading
  loading: "Loading...",

  // Table Columns
  serialNumber: "Serial Number",
  caseName: "Case Name",
  blockchain: "Blockchain",
  address: "Address",
  model: "Model",
  creator: "Creator",
  time: "Time",
  status: "Status",
  operation: "Operation",

  // Status
  verified: "Verified",
  toBeVerified: "To Be Verified",

  // Operations
  view: "View",
  normalSurvey: "Normal Survey",
  keySurvey: "Key Survey",
  delete: "Delete",

  // Dialogs
  verificationResult: "Verification Result",
  tip: "Tip",
  confirmDownload: "Download selected model verification results?",
  yes: "Yes",
  no: "No",
  confirmDeleteAddress: "Delete this address?",
  confirm: "Confirm",
  cancel: "Cancel",

  // Messages
  copySuccess: "Copied successfully!",
  deleteSuccess: "Deleted successfully!",
  deleteCancel: "Deletion cancelled",

  // Guide
  guideStep1: "Click to add model verification",
  guideStep2:
    "Model verification list, click [View Result] to view the source of handling fees for involved addresses.",
};
